module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"change_language":"Naar Nederlands","contact":"Contact us","theme":"Change theme","theme_system":"System preference","theme_dark":"Dark mode","theme_light":"Light mode"},"nl":{"change_language":"Switch to english","contact":"Contact opnemen","theme":"Thema aanpassen","theme_system":"Gebruik systeemvoorkeur","theme_dark":"Donkere modus","theme_light":"Lichte modus"}}')
  delete Component.options._Ctor
}
